import { Directive, ElementRef } from '@angular/core';
import { ConfigService } from '@icc/shared';

@Directive({
    selector: '[iccDisabled]'
})
export class DisabledDirective {
    constructor(
        private el: ElementRef,
        private configService: ConfigService,
    ) {
        const element = this.el.nativeElement as HTMLElement;
        if (this.configService.config?.env?.debug) {
            element.classList.add('icc-disabled');
            element.style.opacity = '0.3';
            element.style.cursor = 'default';
        } else {
            element.style.display = "none";
        }
    }

}
